import { CircularProgress, circularProgressClasses, Typography } from '@mui/material';
import React from 'react';
import styles from './styles';

const Loading = () => {
    const [progress, setProgress] = React.useState(10);
    const [opacity, setOpacity] = React.useState(0.1);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
            setOpacity((prevOpacity) => (prevOpacity >= 1 ? 0.1 : prevOpacity + 0.1));
        }, 800);
        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <Typography component="div" sx={styles.container}>
            <Typography component="div" sx={styles.group}>
                <CircularProgress
                    variant="determinate"
                    sx={{
                        color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                    }}
                    size="10rem"
                    thickness={1}
                    value={100}
                />
                <CircularProgress
                    variant="determinate"
                    disableShrink
                    sx={{
                        color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
                        animationDuration: '550ms',
                        position: 'absolute',
                        left: 0,
                        [`& .${circularProgressClasses.circle}`]: {
                            strokeLinecap: 'round',
                        },
                    }}
                    size="10rem"
                    thickness={1}
                    value={progress}
                />
                <Typography
                    component="div"
                    sx={{
                        ...styles.image_group,
                        opacity,
                    }}
                >
                    <img alt="" src="/images/path_one.svg" style={{ ...styles.path_one }} />
                    <img alt="" src="/images/path_two.svg" style={{ ...styles.path_two }} />
                    <img alt="" src="/images/path_three.svg" style={{ ...styles.path_three }} />
                </Typography>
            </Typography>
        </Typography>
    );
};

export default Loading;
